import {API_HOST, API_URL,} from "../../constants/axios";
import {fetchApi} from "../fetch";
import {URL_SCHEME_REGEX} from "../../libs/urlValidator";
import {wideListItemLabel} from "../../libs/helper";


const convertImage = (imageUrl, imageLink) => {
  return {
    imgUrl: imageUrl,
    imgLink: imageLink,
  };
};
const convertButtons = (messageButtons) => {
  return messageButtons
    .filter((button) => button.isLink !== 'none')
    .map((button) => {
      const buttonData = {
        name: button.name,
        type: "WL",
      };
      if (button.isLink === "link") {
        buttonData.urlMobile = button.link
        buttonData.urlPc = button.pcLink
      } else if (button.isLink === "coupon" && button.coupon) {
        buttonData.couponId = button.coupon.id.toString();
      }
      return buttonData
    });
};
const convertListItems = (listItems) => {
  return listItems.map((item) => {
    return {
      title: item.content,
      imgUrl: item.image,
      urlMobile: item.link,
      urlPc: item.pcLink,
    };
  });
};
const convertCarouselItems = (listItems) => {
  return listItems
    .filter((item) => item.title && item.content)
    .map((item) => {
      return {
        header: item.title,
        message: item.content,
        attachment: {
          buttons: convertButtons(item.messageButtons),
          image: convertImage(item.image, item.link),
        },
      };
    });
};

const convertCarouselTail = (buttons) => {
  if (buttons.length > 0) {
    const button = buttons[0];
    if (button.link) {
      return {
        urlMobile: button.link,
        urlPc: button.pcLink,
      };
    } else {
      return null;
    }
  }
  return null;
};

export const getExpectedCustomerCount = async (id, type, filters, useBrandMsg) => {
  const res = await fetchApi.post(API_URL.EXPECTED_CUSTOMER_COUNT, {
    messageId: id,
    type: type,
    filters: filters,
    useBrandMsg: useBrandMsg
  });
  if (res.status === 200) {
    return res.data;
  } else {
    return 0;
  }
};

/**
 * 발송 모수(Layer 1) picker 용 — 이 채널이 실제로 발송한 1회성 메시지 목록.
 * 실측 채널당 최대 106건이라 서버 페이징 없이 한 번에 받는다.
 */
/**
 * 비회원 친구(카카오 모먼트) 발송 가능 여부.
 *
 * `account_channel.kakao_moment_campaign_id` 유무로 판단한다.
 * 없으면 발송 시점에 실패하므로 화면에서 선택 자체를 막아야 한다.
 */
/**
 * 메시지 단가표 (부가세 포함, 1건당 원).
 *
 * 🔴 **하드코딩하지 말 것.** 정산은 `billing_catalog`(정가표)를 쓰므로 화면도 같은 소스를
 * 봐야 한다. 종전에 프론트가 `22 / 24.2 / 27.5` 를 하드코딩해 실제 청구보다 15~19% 낮게
 * 표시하고 있었다(위험 ST-10 과 같은 유형).
 *
 * 반환 예: `{ FI: 26, FW: 29, MOMENT: 28, ... }`
 */
export const getMessagePrices = async () => {
  const res = await fetchApi.get(API_URL.MESSAGE_PRICES);
  return res.status === 200 ? (res.data?.data ?? {}) : {};
};

export const getMomentAvailable = async () => {
  const res = await fetchApi.get(API_URL.MOMENT_AVAILABLE);
  return res.status === 200 ? res.data?.data === true : false;
};

export const getSentOnetimeMessages = async () => {
  const res = await fetchApi.get(API_URL.SENT_ONETIME_MESSAGES);
  if (res.status === 200) {
    return res.data;
  }
  return { data: [] };
};

export const getTargetCustomers = async (id) => {
  const res = await fetchApi.get(`${API_URL.TARGET_CUSTOMERS}?id=${id}`);
  if (res.status === 200) {
    return res.data;
  } else {
    return 0;
  }
};

/**
 * 쿠폰 코드 잔량 점검. 발송(예약) 등록 **전에** 부른다.
 *
 * 왜 필요한가: 코드형 혜택은 `benefit_code_pool` 에 적재된 수량만큼만 발급된다.
 * 대상 1,200명에게 코드 1,000개를 보내려 하면 종전에는 아무 경고 없이 등록됐고
 * 200명은 발송 시점에 조용히 실패했다.
 *
 * 점검이 실패하면 `null` 을 돌려준다 — 경고는 부가 기능이므로 등록 자체를 막지 않는다.
 */
export const checkCouponCode = async (messageData, targetCount) => {
  try {
    const res = await fetchApi.post(API_URL.COUPON_CODE_CHECK, {
      messageData: messageData,
      targetCount: targetCount
    });
    return res.status === 200 ? res.data?.data ?? null : null;
  } catch (e) {
    return null;
  }
};

/**
 * 쿠폰 코드가 부족하면 운영자에게 물어본다. 진행해도 되면 `true`.
 *
 * 1회성 메시지 화면 3개(일반/AI/AI에이전트)가 같은 문구를 써야 하므로 여기 한 곳에 둔다.
 * 🔴 부족해도 **막지 않는다** — 고객사가 코드를 전달하기 전에 발송일을 먼저 예약해 두는 것이
 * 정상 흐름이다. 운영자가 알고 진행할 수 있게만 한다.
 */
export const confirmCouponCode = async (messageData, targetCount) => {
  const check = await checkCouponCode(messageData, targetCount);
  if (!check?.isShort) return true;

  return window.confirm(
      `${check.message}\n\n`
      + `부족한 만큼은 발송되지 않고 발급 실패로 남습니다.\n`
      + `과금은 실제 성공한 건만 정산됩니다.\n\n`
      + `그래도 등록하시겠습니까?`
  );
};

export const saveNotification = async (status, message, type) => {
  const requestData = {
    ...message,
    status: status,
    type: type,
    messageType: message.messageData.type,
    reservedDate: `${message.issuedAt.date.startDate} ${message.issuedAt.hour}:${message.issuedAt.min}`,
    messageData: message.messageData
  };

  const res = await fetchApi.post(API_URL.SAVE_NOTIFICATION, requestData);
  if (res.status === 200) {
    return res.data;
  } else {
    return 0;
  }
};

export const saveMessage = async (id, status, campaignName, data) => {
  const res = await fetchApi.post(API_URL.SAVE_NOTIFICATION,
      {
        id: id,
        status: status,
        targetType: data.targetType,
        campaignName: campaignName,
        type: "ONETIME",
        filters: data.filters,
        messageType: data.type,
        reservedDate: data.reservedTime,
        messageData: data,
        isSendMoment: data.isNonMember
      }
      );
  return res.data;
};

/**
 * 1회성 메시지 목록. `startDate`/`endDate` 가 null 이면 **기간 조건 없이** 조회한다("전체" 탭).
 *
 * 날짜 키를 조건부로 넣는 이유: `new URLSearchParams({startDate: undefined})` 는 문자열
 * `"undefined"` 를 보내고, 서버는 `LocalDate.parse` 에서 500 을 낸다. 서버(VolatilityMessageController)는
 * 두 파라미터가 `required = false` 라 **키가 없으면** 날짜 조건을 건너뛴다.
 */
export const getVolatilityMessages = async (
  startDate,
  endDate,
  type,
  page = 0,
  size = 9999,
  sort = "ISSUED_AT" // "ISSUED_AT"(발송일순) | "CREATED_AT"(생성일순). 서버 ListSort 이름과 같다.
) => {
  const searchParam = new URLSearchParams({ type, page, size, sort });
  if (startDate && endDate) {
    searchParam.set("startDate", startDate);
    searchParam.set("endDate", endDate);
  }
  const res = await fetchApi.get(API_URL.GET_VOLATILITY_MESSAGES + "?" + searchParam.toString());
  return res.data;
};

/**
 * 목록 상단 대시보드 숫자(발송 예약 / 발송 결과 / 발송 관리). 목록과 같은 기간(생성일 기준)으로 센다.
 * 날짜가 null 이면 기간 조건 없음. 실패하면 null — 대시보드는 부가 정보라 목록을 막지 않는다.
 */
export const getVolatilityMessageSummary = async (startDate, endDate, type) => {
  const searchParam = new URLSearchParams({ type });
  if (startDate && endDate) {
    searchParam.set("startDate", startDate);
    searchParam.set("endDate", endDate);
  }
  try {
    const res = await fetchApi.get(API_URL.VOLATILITY_MESSAGE_SUMMARY + "?" + searchParam.toString());
    return res.status === 200 ? (res.data?.data ?? null) : null;
  } catch (e) {
    return null;
  }
};

export const getVolatilityMessage = async (id) => {
  const res = await fetchApi.get(
    API_URL.GET_VOLATILITY_MESSAGE.replace("{id}", id)
  );
  if (res.status === 200) {
    return res.data;
  } else {
    return {};
  }
};

export const getVolatilityClickUsers = async (id, startDate, endDate) => {
  const res = await fetchApi.get(
    `${API_URL.GET_VOLATILITY_CLICK_USERS.replace("{id}", id)}${startDate ? `?startDate=${startDate}&endDate=${endDate}` : ""}`
  );
  if (res.status === 200) {
    return res.data;
  } else {
    return {};
  }
};

/**
 * 미발송(임시저장·예약) 1회성 메시지 완전 삭제.
 * 발송 이력이 있는 상태는 서버가 거부하고 false 를 돌려준다.
 */
export const deleteVolatilityMessage = async (id) => {
  const res = await fetchApi.delete(API_URL.DELETE_VOLATILITY_MESSAGE.replace("{id}", id));
  return res?.status === 200 && res?.data?.data === true;
};

export const cancelReserved = async (id) => {
  const res = await fetchApi.post(
      API_URL.VOLATILITY_MESSAGE_RESERVED_CANCEL.replace("{id}", id)
  );
  return res.data;
};

export const copyMessage = async (id) => {
  const res = await fetchApi.post(
      API_URL.VOLATILITY_MESSAGE_COPY.replace("{id}", id)
  );
  return res.data;
};

/**
 * 메시지 내용 검증 — 통과하면 null, 실패하면 **사유 문자열**을 돌려준다.
 *
 * boolean 만 돌려주던 validContent 를 이 함수 위에 다시 세운 이유:
 * 단계 이동은 버튼 비활성만으로 충분하지만, **테스트 발송은 왜 안 되는지 알려줘야 하기 때문**이다.
 * (2026-07-29 인시던트: 필수 항목이 빈 채로 테스트 발송 → 발송 서버 400 → redirect 500 → 화면 튕김)
 */
export const validateContentReason = (messageData) => {
  const type = messageData?.type
  if (type === "FT" || type === "FI") {
    if (!(messageData.content?.length > 0)) return "메시지 내용을 입력해 주세요."
    return validateButtonsReason(messageData.buttons) ?? validateCouponReason(messageData.coupon)
  } else if (type === "FW") {
    if (!(messageData.content?.length > 0)) return "메시지 내용을 입력해 주세요."
    if (!validChangeOfLine(messageData.content)) return "메시지 내용의 줄바꿈은 3번 미만이어야 합니다."
    if (!(messageData.image?.imgUrl?.length > 0)) return "이미지를 첨부해 주세요."
    return validateButtonsReason(messageData.buttons) ?? validateCouponReason(messageData.coupon)
  } else if (type === "FL") {
    // 와이드 리스트형: 메인 아이템 + 리스트 항목 = 3~4개이며, **모든** 아이템이 내용·이미지·링크를 갖춰야 한다.
    // 구 로직은 '유효한 아이템이 3개 이상'만 세어(filter(...).length > 2) 4개 중 1개(예: 메인 아이템)가
    // 비어도 통과시켰고, 그대로 발송하면 발송 서버가 400(Item.title non-null 위반)을 냈다.
    if (!(messageData.header?.length > 0)) return "타이틀을 입력해 주세요."
    // 전개(...)로 복사하는 이유: 편집 중 items[2] 부터 채우면 배열에 hole 이 생기는데
    // 배열 순회 메서드는 hole 을 건너뛴다. 전개하면 hole 이 undefined 로 바뀌어 정상적으로 걸린다.
    const items = [...(messageData.items ?? [])]
    if (!(items.length > 2)) return "리스트 항목을 3개 이상 입력해 주세요."
    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      // 편집 화면(WideListMessageSetting) 라벨과 같은 함수를 쓴다 — 번호가 어긋나지 않게.
      const label = wideListItemLabel(i)
      if (!(item?.imgUrl?.length > 0)) return `${label}의 이미지를 첨부해 주세요.`
      if (!(item?.title?.length > 0)) return `${label}의 내용을 입력해 주세요.`
      if (!validChangeOfLine(item.title)) return `${label}의 내용은 줄바꿈이 3번 미만이어야 합니다.`
      if (!(item?.urlMobile?.length > 0)) return `${label}의 링크를 입력해 주세요.`
    }
    return null
  } else if (type === "FC") {
    const carousels = [...(messageData.carousels ?? [])]
    if (!(carousels.length > 1)) return "캐러셀을 2개 이상 입력해 주세요."
    for (let i = 0; i < carousels.length; i++) {
      const carousel = carousels[i]
      const label = `캐러셀 ${i + 1}`
      if (!(carousel?.header?.length > 0)) return `${label}의 타이틀을 입력해 주세요.`
      if (!(carousel?.message?.length > 0)) return `${label}의 내용을 입력해 주세요.`
      if (!validChangeOfLine(carousel.message)) return `${label}의 내용은 줄바꿈이 3번 미만이어야 합니다.`
      if (!(carousel.attachment?.image?.imgUrl?.length > 0)) return `${label}의 이미지를 첨부해 주세요.`
      const reason = validateButtonsReason(carousel.attachment?.buttons, `${label} `)
          ?? validateCouponReason(carousel.attachment?.coupon, `${label} `)
      if (reason) return reason
    }
    return null
  }
  return "메시지 유형을 선택해 주세요."
}

/** 단계 이동 버튼 활성/비활성용 boolean 래퍼. 규칙은 validateContentReason 한 곳에만 둔다. */
export const validContent = (messageData) => validateContentReason(messageData) === null

const validateButtonsReason = (buttons, prefix = "") => {
  const list = [...(buttons ?? [])]
  for (let i = 0; i < list.length; i++) {
    const button = list[i]
    // 웹링크(WL) 버튼만 URL 필수 — 봇키워드/채널추가 등은 검사 대상이 아니다(백엔드 validateUrls 와 동일 기준).
    if (button?.type !== "WL") continue
    const label = `${prefix}버튼 ${i + 1}`
    if (!(button.name?.length > 0)) return `${label}의 이름을 입력해 주세요.`
    if (!(button.urlMobile?.length > 0)) return `${label}의 링크를 입력해 주세요.`
    if (!URL_SCHEME_REGEX.test(button.urlMobile)) return `${label}의 링크는 http:// 또는 https:// 로 시작해야 합니다.`
  }
  return null
}

const validateCouponReason = (coupon, prefix = "") => {
  if (!coupon) return null
  if (!(coupon.title?.length > 6)) return `${prefix}쿠폰 이름을 입력해 주세요.`
  if (!(coupon.description?.length > 0)) return `${prefix}쿠폰 설명을 입력해 주세요.`
  // 혜택(benefitId)을 연결했으면 링크는 발송 시점에 서버가 만든다 → 링크 검사 생략.
  if (isNaN(coupon.benefitId)) {
    if (!(coupon.urlMobile?.length > 0)) return `${prefix}쿠폰 링크를 입력해 주세요.`
    if (!URL_SCHEME_REGEX.test(coupon.urlMobile)) return `${prefix}쿠폰 링크는 http:// 또는 https:// 로 시작해야 합니다.`
  }
  return null
}

const validChangeOfLine = (text) => {
  return (text.match(/\n/g) || []).length < 3
}

export const testSend = async (userIdList, isBrandMsg, messageData, automateId) => {
  const res = await fetchApi.post(API_URL.TEST_VOLATILITY_MESSAGE, {
    userIdList: userIdList,
    isBrandMsg: isBrandMsg,
    messageData: messageData,
    automateId: automateId
  });
  return res.data;
};

export const testPhoneSend = async (messageData, phoneNumber) => {
  const res = await fetchApi.post(API_URL.TEST_PHONE_VOLATILITY_MESSAGE, {
    messageData: messageData,
    phoneNumber: phoneNumber
  });
  return res.data;
};

export const messageChatStreamGeneration = (id, text) => {
  return fetchApi.source(`${API_HOST}${API_URL.AI_CHAT.replace("{id}", id)}?text=${encodeURIComponent(text)}`)
}

export const aiRecommendedUsers = async (id, messageData) => {
  const res = await fetchApi.post(API_URL.AI_RECOMMENDED_USERS.replace("{id}", id), {
    messageData: messageData
  });
  return res.data;
};

export const getUseBrandMsg = async () => {
  const res = await fetchApi.get(API_URL.USE_BRAND_MSG);
  if (res.status === 200) {
    return res.data;
  } else {
    return false;
  }
};